function init() {
  
  const smallScreen = (window.innerWidth <= 767) ? true : false;
  const headerElement                                 = document.querySelector('.header');
  const headerHideClassName                           = 'header--hide';
  const propertysearchbarElement                      = document.querySelector('.propertysearch--widget');
  const propertysearchbarStickyClassName              = 'propertysearch--sticky';
  const propertysearchbarStickyBoundaryPriorClassName = 'container--boundary1350';
  const propertysearchbarStickyBoundaryClassName      = 'container--boundary1840';

  if (!smallScreen) {
    if (headerElement && propertysearchbarElement) {
      const propertysearchbarContainer = propertysearchbarElement.querySelector('.container');

      if (!window.propertysearchbarTopOffset) {
        window.propertysearchbarTopOffset = propertysearchbarElement.offsetTop;
      }

      const propertysearchbarThreshold = 100;

      if (window.pageYOffset > propertysearchbarTopOffset - propertysearchbarThreshold) {
        headerElement.classList.add(headerHideClassName);
        propertysearchbarElement.classList.add(propertysearchbarStickyClassName);
        propertysearchbarContainer.classList.add(propertysearchbarStickyBoundaryClassName);
        propertysearchbarContainer.classList.remove(propertysearchbarStickyBoundaryPriorClassName);
      } else {
        headerElement.classList.remove(headerHideClassName);
        propertysearchbarElement.classList.remove(propertysearchbarStickyClassName);
        propertysearchbarContainer.classList.remove(propertysearchbarStickyBoundaryClassName);
        propertysearchbarContainer.classList.add(propertysearchbarStickyBoundaryPriorClassName);
      }
    }
  }

}

export default init;



// WEBPACK FOOTER //
// ./wp-content/themes/template/res/js/modules/Propertysearchbar.js